import * as THREE from 'three';

export interface ComponentMeta {
  id: string;
  name: string;
  english: string;
  model: string;
  function: string;
  connection: string;
  mistake: string;
  tip: string;
}

export function markInteractive(object: THREE.Object3D, meta: ComponentMeta): void {
  object.traverse((child) => {
    child.userData.interactiveRoot = object;
  });
  object.userData.meta = meta;
}

export function disposeObject(root: THREE.Object3D): void {
  root.traverse((object) => {
    if (object instanceof THREE.Mesh || object instanceof THREE.Line) {
      object.geometry.dispose();
      const materials = Array.isArray(object.material) ? object.material : [object.material];
      materials.forEach((material) => {
        if ('map' in material && material.map instanceof THREE.Texture) material.map.dispose();
        material.dispose();
      });
    }
  });
}
